{
  "en": {
    "pagination": {
      "next": "Next page",
      "page_report": "Page {page} of {total}",
      "previous": "Previous page",
      "report": "Showing {first} to {last} of {total}",
      "total": "Total items: {total}"
    }
  }
}
